import React from "react";
import {UI, PLACEHOLDERS, ICONS} from "../../data/constants";
import "../FontSelector/index.css";
import "../LayoutSelector/index.css";
import "../IconSelector/index.css";

type LayoutOption = {id: number; iconId: number | string};
export function LayoutControl({channel, value, options, onChange, compact = false}: {
  channel: string; value: number; options: LayoutOption[]; onChange: (value: number) => void; compact?: boolean;
}) {
  if (compact) return <label>Layout<select aria-label="Layout" value={value} onChange={(e) => onChange(Number(e.target.value))}>
    {options.map((option) => <option key={option.id} value={option.id}>{option.id}</option>)}
  </select></label>;
  return <><span className="label">Layout</span><div className="layout-selector">
    {options.map((option) => <button key={option.id} aria-label={`Layout ${option.id}`} value={option.id}
      className={`layout-button${value === option.id ? " selected" : ""}`} onClick={() => onChange(option.id)}
      style={{backgroundImage: `url(${UI}/Layouts/${channel}/${option.iconId}.svg)`}} />)}
  </div></>;
}
export function FontControl({value, onChange}: {value: string; onChange: (value: string) => void}) {
  return <div className="font-selector">{Object.keys(PLACEHOLDERS).map((font) => <button key={font}
    className={`font-button${value === font ? " selected" : ""}`} onClick={() => onChange(font)}>{font.toUpperCase()}</button>)}</div>;
}
export function IconControl({channel, value, amount, onChange}: {channel: string; value: string; amount: number; onChange: (value: string) => void}) {
  const icons = channel === "email" ? ["9", "10", "11", "13"] : ICONS;
  return <div className="icon-selector">{icons.slice(0, amount).map((icon) => <button key={icon}
    aria-label={`Icon ${icon}`} value={icon} className={`icon-button${value === icon ? " selected" : ""}`}
    onClick={() => onChange(icon)} style={{backgroundImage: `url(${UI}/Icons/${icon}.svg)`}} />)}</div>;
}
